import { DieBayerischeLogo } from "@App/Components/atoms/whitelabel/logos/DieBayerischeLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Die Bayerische whitelabel.
 * Extends the default configuration with specific settings for Die Bayerische.
 */
export const config: Partial<Config> = {
  slug: "bayerische-schadenmeldung",
  navbar: {
    logos: {
      right: {
        component: <DieBayerischeLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.diebayerische.de/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
